module.exports = __webpack_public_path__ + "img/octagon.5a722f11.svg";